import api from './api';

const KEY = 'personal_blog.frontend.cloud_capability.v1';

export type CloudCapability = 'unknown' | 'supported' | 'unsupported';

export function getCloudCapability(): CloudCapability {
  const v = localStorage.getItem(KEY) as CloudCapability | null;
  if (v === 'supported' || v === 'unsupported') return v;
  return 'unknown';
}

export function setCloudCapability(v: CloudCapability) {
  localStorage.setItem(KEY, v);
}

export async function probeCloudCapability(): Promise<CloudCapability> {
  const cached = getCloudCapability();
  if (cached !== 'unknown') return cached;
  try {
    // 只要 /api/today-data 存在，说明后端已升级到支持云端功能的版本
    await api.get('/today-data');
    setCloudCapability('supported');
    return 'supported';
  } catch (e: any) {
    if (e?.response?.status === 404) {
      setCloudCapability('unsupported');
      return 'unsupported';
    }
    // 其它错误（401/网络问题）不缓存，避免误判
    return 'unknown';
  }
}

